const test = {
  accountId: '89a922449121f7c2',
  dataSourceId: 'a36d2cf571d6f995',
  host: 'https://collect.test.xiaopeng.com',
  version: '1.0.0',
};

const prod = {
  accountId: '84eafaa69d23412f',
  dataSourceId: 'bec9d29365229e49',
  host: 'https://collect.xiaopeng.com',
  version: '1.0.0',
};


export default {
  test,
  prod,
};
